import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import type { AuthState } from "../auth/AuthProvider";
import { businessesQueryOptions } from "../queries";
import { BusinessCard } from "../home/BusinessCard";

function HomeRoute() {
  return <HomeScreen auth={Route.useRouteContext().auth} />;
}

export const Route = createFileRoute("/_authed/home")({
  component: HomeRoute,
});

// Exported for tests (rendered without a router).
export function HomeScreen({ auth }: { auth: AuthState }) {
  const businesses = useQuery(businessesQueryOptions(auth));

  if (businesses.isLoading)
    return <main className="grid min-h-[60vh] place-items-center text-slate-400">Loading…</main>;
  if (businesses.isError || !businesses.data)
    return (
      <main className="grid min-h-[60vh] place-items-center p-6 text-center text-slate-500">
        <div>
          <p>Something went wrong.</p>
          <button onClick={() => businesses.refetch()} className="mt-3 text-teal-600 underline">Try again</button>
        </div>
      </main>
    );

  const list = businesses.data.businesses;
  return (
    <main className="mx-auto max-w-lg space-y-4 p-4">
      <h1 className="text-lg font-semibold text-slate-800">Your carwashes</h1>
      {list.length === 0 ? (
        <p className="rounded-xl border border-dashed border-slate-300 p-6 text-center text-slate-500">
          No visits yet — visit a participating carwash and your history will appear here.
        </p>
      ) : (
        list.map((b) => <BusinessCard key={b.businessId} business={b} auth={auth} />)
      )}
    </main>
  );
}
